/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateFileIndex } from '../../axios/candidateFileIndex'
import type {
	CandidateFileIndexError,
	CandidateFileIndexPathParams,
	CandidateFileIndexResponse,
} from '../../types/CandidateFileIndex'

export const candidateFileIndexQueryKey = (candidateId: CandidateFileIndexPathParams['candidateId']) =>
	[{ url: '/candidates/:candidateId/files', params: { candidateId } }] as const

export type CandidateFileIndexQueryKey = ReturnType<typeof candidateFileIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateFileController.php CandidateFileController::index */
export function candidateFileIndexQueryOptions(
	candidateId: CandidateFileIndexPathParams['candidateId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CandidateFileIndexResponse,
		AxiosError<CandidateFileIndexError>,
		CandidateFileIndexResponse,
		CandidateFileIndexQueryKey
	>({
		queryKey: candidateFileIndexQueryKey(candidateId),
		queryFn: ({ signal }) => candidateFileIndex(candidateId, { signal, ...config }).then(res => res.data),
		enabled: !!candidateId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateFileController.php CandidateFileController::index */
export function useCandidateFileIndex<TSelectData = CandidateFileIndexResponse>(
	candidateId: CandidateFileIndexPathParams['candidateId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidateFileIndexResponse,
					AxiosError<CandidateFileIndexError>,
					TSelectData,
					CandidateFileIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidateFileIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidateFileIndexQueryOptions(candidateId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateFileController.php CandidateFileController::index */
export function useCandidateFileIndexSuspense<TSelectData = CandidateFileIndexResponse>(
	candidateId: CandidateFileIndexPathParams['candidateId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidateFileIndexResponse,
					AxiosError<CandidateFileIndexError>,
					TSelectData,
					CandidateFileIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidateFileIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidateFileIndexQueryOptions(candidateId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
